import type {Transaction, TransactionApi, TransactionsApiResponse, TransactionsResult} from "./transactions.types";

const resolveCounterparty = (api: TransactionApi): string | null => {
  const details = api.details ?? {};
  if (api.transaction_type === "transfer-sent") return details.recipient_name ?? null;
  if (api.transaction_type === "transfer-received") return details.sender_name ?? null;
  return null;
};

const adaptTransaction = (api: TransactionApi): Transaction => {
  const rawId = api.ID ?? api.id ?? `${api.transaction_type}-${api.created_at ?? api.createdAt ?? ""}`;
  const createdAt = api.created_at ?? api.createdAt ?? "";
  return {
    id: String(rawId),
    amount: typeof api.amount === "number" ? api.amount : Number(api.amount ?? 0),
    formattedAmount: api.formatted_amount ?? "",
    currency: api.currency ?? "",
    transactionType: api.transaction_type,
    createdAt,
    counterpartyName: resolveCounterparty(api),
    reference: api.details?.reference ?? null,
  };
};

export const adaptTransactions = (response: TransactionsApiResponse): TransactionsResult => {
  const payload = response?.data;
  const list = Array.isArray(payload?.data) ? payload.data : [];
  return {
    items: list.map(adaptTransaction),
    total: payload?.total ?? list.length,
    page: payload?.page ?? 1,
    limit: payload?.limit ?? list.length,
  };
};
